class HeaderNav {
    constructor(item) {
        // Переменные
        this.element = item;
        this.menuBtn = this.element.querySelector('.js-header-nav-menu-btn');
        this.menu = this.element.querySelector('.js-header-nav-menu');
        this.dropBtn = this.element.querySelector('.js-header-nav-drop-btn');
        this.drop = this.element.querySelector('.js-header-nav-drop');

        // Функции
        this.setListeners();
    };

    setListeners() {
        this.menuBtn.addEventListener('click', () => {
            if (window.innerWidth < 1024) {
                this.menu.classList.toggle('is-active');
            }
        });

        this.dropBtn.addEventListener('click', () => {
            if (window.innerWidth < 1024) {
                this.drop.classList.toggle('is-active');
            }
        });
    }
};

document.querySelectorAll('.js-header-nav').forEach((item) => new HeaderNav(item));
